import request from '@/services/request';
import {baseApi} from '../config'
/**
 * @description 手机号登录
 */
export const phoneLogin=(params:any)=>{
  return request.post(`${baseApi}/login/phoneLogin`,params)
}
/**
  * @description 发送手机验证码
  */
export const sendCode=(params:any)=>{
   return request.post(`${baseApi}/login/sendCode`,params)
}
/**
  * @description 获取个人用户信息
  */
export const getUserInfo=(params:any)=>{
   return request.post(`${baseApi}/user/getUserInfo`,params)
}
/**
  * @description 更新用户个人信息
  */
export const updateUserInfo=(params:any)=>{
  return request.post(`${baseApi}/user/updateUserInfo`,params)
}